@if (state) {
    <div class="modal" [@fade]>
        <div class="overlay"></div>
        <div class="window" [style.max-width]="maxWidth" [style.max-height]="maxHeight">
            <ng-content select="fui-modal-window"></ng-content>
        </div>
    </div>
}
